import get from 'transmute/get';
import { getFile } from './fileUploadGetters';
export const getFileSize = fileUpload => {
  const file = getFile(fileUpload);
  if (file) {
    return get('size', file) || 0;
  }
  return 0;
};